import { ENTERPRISE_ID } from "@Constants/localStorage";
import { Api } from "@Configs/api/api";
import apiConfig from "@Configs/api/api.config";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { API_NINETICK_ORDER, API_NINETICK_PLANS, API_NINETICK_TRANSACTIONS } from "./endpoint";

class NinetickBillingApi extends Api {
  public constructor(config: AxiosRequestConfig) {
    super(config);
    this.getPlans = this.getPlans.bind(this);
    this.getTransactions = this.getTransactions.bind(this);
    this.createOrder = this.createOrder.bind(this);
  }

  public getPlans(params?: any): Promise<any> {
    return this.get<any>(API_NINETICK_PLANS, {
      headers: {
        "x-business-id": localStorage.getItem(ENTERPRISE_ID) || "",
      },
      params,
    })
      .then((response: AxiosResponse<any>) => response.data)
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public createOrder(data: any): Promise<any> {
    return this.post<any>(API_NINETICK_ORDER, JSON.stringify(data), {
      headers: {
        "x-business-id": localStorage.getItem(ENTERPRISE_ID) || "",
      },
    })
      .then((response: AxiosResponse<any>) => response.data)
      .catch((error: AxiosError) => {
        throw error;
      });
  }

  public getTransactions(params?: any): Promise<any> {
    return this.get<any>(API_NINETICK_TRANSACTIONS, {
      headers: {
        "x-business-id": localStorage.getItem(ENTERPRISE_ID) || "",
      },
      params,
    })
      .then((response: AxiosResponse<any>) => response.data)
      .catch((error: AxiosError) => {
        throw error;
      });
  }
}

const ninetickBillingApi = new NinetickBillingApi(apiConfig);
export default ninetickBillingApi;
